const discussions_pt = require('./discussions.json')
export default discussions_pt
